<script>
  import TaskItem from "./taskItem.svelte";
  let data = TaskItem;
  import { user } from "../../firebase";
  import TaskListitemComponent from "./TaskListitem.svelte";
  import { conversion, lang } from "../../store/store";

  let userTasks;
  $user.tasks.subscribe((v) => {
    userTasks = Object.entries(v);
    console.log(userTasks);
  });

  let x = false;

  function ControlAnimation() {
    x = !x;

    if (x == true) {
      triggerAnimation();
    } else untriggerAnimation();
  }

  function triggerAnimation() {
    let elem = document.getElementById("tasktestWrapperID");
    elem.style.color = "red";
    elem.style.minHeight = "10rem";
    elem.style.maxHeight = "13rem";
  }

  function untriggerAnimation() {
    let elem = document.getElementById("tasktestWrapperID");
    elem.style.maxHeight = "0rem";
    elem.style.minHeight = "0rem";
  }

  let state = "open";
  let statusArray = [
    $conversion[$lang].MyTasks.SubTitles[1],
    $conversion[$lang].MyTasks.SubTitles[2],
    $conversion[$lang].MyTasks.SubTitles[3],
    $conversion[$lang].MyTasks.SubTitles[4],
    $conversion[$lang].MyTasks.SubTitles[5],
  ];
</script>

<!-- 
<div class="openTasks_header">
    <h5>Pending <span>(See All)</span></h5>
    <div on:click={ControlAnimation} class="openTasks_icon">
        {#if x == false}
            <i class="bx bx-down-arrow-circle" />
        {:else}<i class="bx bx-up-arrow-circle" />{/if}
    </div>
</div>
<div class="tasktestWrapper" id="tasktestWrapperID">
    {#each userTasks as [id, task]}
        <a href="/TaskItemDetails/{id}" class="openTasks">
            <div class="taskItem_Wrapper">
                <div class="u-taskName">
                    <h6 class="mutedText">Task Name</h6>
                    <h5>{task.name}</h5>
                </div>
                <div class="u-taskPriority">
                    <h6 style="text-align:center;" class="mutedText">
                        Priority
                    </h6>
                    {#if task.priority}
                        <div
                            style="color:var(--priority{task.priority.name})"
                            class="priorityContainer">
                            <div
                                style={task.priority.name == 'low' ? 'transform:rotate(180deg)' : ''}
                                class="arrow">
                                <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        style="fill:var(--priority{task.priority.name})"
                                        d="M8.92017 0.209705L9.0438 0.292893L15.6052 5.29289C16.1177 5.68342 16.1177 6.31658 15.6052 6.70711C15.1321 7.06759 14.3878 7.09532 13.873 6.7903L13.7494 6.70711L9.42815 3.415V15C9.42815 15.5523 8.84063 16 8.11587 16C7.44289 16 6.88822 15.614 6.81242 15.1166L6.80359 15V3.415L2.48239 6.70711C2.00933 7.06759 1.26497 7.09532 0.750172 6.7903L0.626546 6.70711C0.153489 6.34662 0.117101 5.77939 0.517379 5.3871L0.626546 5.29289L7.18795 0.292893C7.66101 -0.0675907 8.40537 -0.0953203 8.92017 0.209705Z" />
                                </svg>
                            </div>
                            <h5>{task.priority.name}</h5>
                        </div>
                    {/if}
                </div>
                <div class="u-taskStatus">
                    <div
                        style="background-color:#2C8F73;color:white"
                        class="buttonStatus">
                        <div>Pending</div>
                    </div>
                </div>
            </div>
        </a>
    {/each}
</div>
<div class="openTasks_header">
    <h5>Open <span>(See All)</span></h5>
    <div class="openTasks_icon"><i class="bx bx-down-arrow-circle" /></div>
</div>
{#each userTasks as [id, task]}
    {#if task.statusID == 0}
        <div class="openTasks">
            <div class="taskItem_Wrapper">
                <div class="taskName">
                    <h6 class="mutedText">Task Name</h6>
                    <h5>{task.name}</h5>
                </div>
                <div class="taskMessages">
                    <h6 class="mutedText">Messages</h6>
                    <div class:green={task.messages == 0} class="msgContainer">
                        <h5>{task.messages}</h5>
                    </div>
                </div>
                <div class="taskEstimation">
                    <h6 class="mutedText">Estimate</h6>
                    <h5>{task.estimate.min}h - {task.estimate.max}h</h5>
                </div>
                <div class="taskTime">
                    <h6 class="mutedText">Spent Time</h6>
                    <h5>{task.spentTime}</h5>
                </div>
                <div class="taskDelieveryday">
                    <h6 class="mutedText">Delievery date</h6>
                    <h5>{task.delivery}</h5>
                </div>

                <div class="taskPriority">
                    <h6 class="mutedText">Priority</h6>
                    {#if task.priority}
                        <div
                            style="color:var(--priority{task.priority})"
                            class="priorityContainer">
                            <div
                                style={task.priority == 'low' ? 'transform:rotate(180deg)' : ''}
                                class="arrow">
                                <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        style="fill:var(--priority{task.priority})"
                                        d="M8.92017 0.209705L9.0438 0.292893L15.6052 5.29289C16.1177 5.68342 16.1177 6.31658 15.6052 6.70711C15.1321 7.06759 14.3878 7.09532 13.873 6.7903L13.7494 6.70711L9.42815 3.415V15C9.42815 15.5523 8.84063 16 8.11587 16C7.44289 16 6.88822 15.614 6.81242 15.1166L6.80359 15V3.415L2.48239 6.70711C2.00933 7.06759 1.26497 7.09532 0.750172 6.7903L0.626546 6.70711C0.153489 6.34662 0.117101 5.77939 0.517379 5.3871L0.626546 5.29289L7.18795 0.292893C7.66101 -0.0675907 8.40537 -0.0953203 8.92017 0.209705Z" />
                                </svg>
                            </div>
                            <h5>{task.priority}</h5>
                        </div>
                    {/if}
                </div>
                <div class="taskStatus">
                    <div
                        style="background-color:#2C8F73;color:white"
                        class="buttonStatus">
                        <div>Done</div>
                    </div>
                </div>
            </div>
        </div>
    {/if}
{/each}

<div class="openTasks_header topMarginHeaders">
    <h5>In progress <span>(See All)</span></h5>
    <div class="openTasks_icon"><i class="bx bx-down-arrow-circle" /></div>
</div>
{#each userTasks as [id, task]}
    {#if task.statusID == 1}
        <div class="openTasks">
            <div class="taskItem_Wrapper">
                <div class="taskName">
                    <h6 class="mutedText">Task Name</h6>
                    <h5>{task.name}</h5>
                </div>
                <div class="taskMessages">
                    <h6 class="mutedText">Messages</h6>
                    <div class:green={task.messages == 0} class="msgContainer">
                        <h5>{task.messages}</h5>
                    </div>
                </div>
                <div class="taskEstimation">
                    <h6 class="mutedText">Estimate</h6>
                    <h5>{task.estimate.min}h - {task.estimate.max}h</h5>
                </div>
                <div class="taskTime">
                    <h6 class="mutedText">Spent Time</h6>
                    <h5>{task.spentTime}</h5>
                </div>
                <div class="taskDelieveryday">
                    <h6 class="mutedText">Delievery date</h6>
                    <h5>{task.delivery}</h5>
                </div>
                <div class="taskPriority">
                    <h6 class="mutedText">Priority</h6>
                    {#if task.priority}
                        <div
                            style="color:var(--priority{task.priority})"
                            class="priorityContainer">
                            <div
                                style={task.priority == 'low' ? 'transform:rotate(180deg)' : ''}
                                class="arrow">
                                <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        style="fill:var(--priority{task.priority})"
                                        d="M8.92017 0.209705L9.0438 0.292893L15.6052 5.29289C16.1177 5.68342 16.1177 6.31658 15.6052 6.70711C15.1321 7.06759 14.3878 7.09532 13.873 6.7903L13.7494 6.70711L9.42815 3.415V15C9.42815 15.5523 8.84063 16 8.11587 16C7.44289 16 6.88822 15.614 6.81242 15.1166L6.80359 15V3.415L2.48239 6.70711C2.00933 7.06759 1.26497 7.09532 0.750172 6.7903L0.626546 6.70711C0.153489 6.34662 0.117101 5.77939 0.517379 5.3871L0.626546 5.29289L7.18795 0.292893C7.66101 -0.0675907 8.40537 -0.0953203 8.92017 0.209705Z" />
                                </svg>
                            </div>
                            <h5>{task.Priority}</h5>
                        </div>
                    {/if}
                </div>
                <div class="taskStatus">
                    <div
                        style="background-color:#3F8CFF;color:white"
                        class="buttonStatus">
                        <div>In Progress</div>
                    </div>
                </div>
            </div>
        </div>
    {/if}
{/each}

<div class="openTasks_header topMarginHeaders">
    <h5>Finished <span>(See All)</span></h5>

    <div class="openTasks_icon"><i class="bx bx-down-arrow-circle" /></div>
</div>
{#each userTasks as [id, task]}
    {#if task.statusID == 2}
        <div class="openTasks">
            <div class="taskItem_Wrapper">
                <div class="taskName">
                    <h6 class="mutedText">Task Name</h6>
                    <h5>{task.name}</h5>
                </div>
                <div class="taskMessages">
                    <h6 class="mutedText">Messages</h6>
                    <div class:green={task.messages == 0} class="msgContainer">
                        <h5>{task.messages}</h5>
                    </div>
                </div>
                <div class="taskEstimation">
                    <h6 class="mutedText">Estimate</h6>
                    <h5>{task.estimate.min}h - {task.estimate.max}h</h5>
                </div>
                <div class="taskTime">
                    <h6 class="mutedText">Spent Time</h6>
                    <h5>{task.spentTime}</h5>
                </div>
                <div class="taskDelieveryday">
                    <h6 class="mutedText">Delievery date</h6>
                    <h5>{task.delivery}</h5>
                </div>
                <div class="taskPriority">
                    <h6 class="mutedText">Priority</h6>
                    {#if task.priority}
                        <div
                            style="color:var(--priority{task.priority})"
                            class="priorityContainer">
                            <div
                                style={task.priority == 'low' ? 'transform:rotate(180deg)' : ''}
                                class="arrow">
                                <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        style="fill:var(--priority{task.priority})"
                                        d="M8.92017 0.209705L9.0438 0.292893L15.6052 5.29289C16.1177 5.68342 16.1177 6.31658 15.6052 6.70711C15.1321 7.06759 14.3878 7.09532 13.873 6.7903L13.7494 6.70711L9.42815 3.415V15C9.42815 15.5523 8.84063 16 8.11587 16C7.44289 16 6.88822 15.614 6.81242 15.1166L6.80359 15V3.415L2.48239 6.70711C2.00933 7.06759 1.26497 7.09532 0.750172 6.7903L0.626546 6.70711C0.153489 6.34662 0.117101 5.77939 0.517379 5.3871L0.626546 5.29289L7.18795 0.292893C7.66101 -0.0675907 8.40537 -0.0953203 8.92017 0.209705Z" />
                                </svg>
                            </div>
                            <h5>{task.Priority}</h5>
                        </div>
                    {/if}
                </div>
                <div class="taskStatus">
                    <div
                        style="background-color:rgba(125, 133, 146, 0.14);color:#7D8592"
                        class="buttonStatus">
                        <div>To Do</div>
                    </div>
                </div>
            </div>
        </div>
    {/if}
{/each} -->

{#each statusArray as item, i}
  <TaskListitemComponent obj={userTasks} state={item} {i} />
{/each}

<!-- <TaskListitemComponent obj={userTasks} {state} /> -->

<!-- 
{#each statusArray as item}
    {#each userTasks as [id, task]}
        {#if task.status.type == item}
            <TaskListitemComponent obj={task} state={item} />
        {/if}
    {/each}
{/each} -->

<style>
  * {
    padding: 0;
    margin: 0;
  }
</style>
